module.exports = __webpack_public_path__ + "static/media/my-library.79202bd0.svg";